import { render, staticRenderFns } from "./BooksView.vue?vue&type=template&id=e49363fa&scoped=true&"
import script from "./BooksView.vue?vue&type=script&lang=js&"
export * from "./BooksView.vue?vue&type=script&lang=js&"
import style0 from "./BooksView.vue?vue&type=style&index=0&id=e49363fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49363fa",
  null
  
)

export default component.exports